// 2_components/products_block_amount_to_cart.js
// For listed products that are already in the cart, adds a +/- quantity stepper
// next to the add-to-cart button and syncs it with the Shoptet cart (dataLayer
// cartInfo). Re-runs on cart updates, page content loads and search results.

export function init() {
	document.addEventListener("ShoptetCartUpdated", function () {
		changeAddToCartButtonToIncreaseDecrease();
	});
	document.addEventListener("ShoptetDOMPageContentLoaded", function () {
		changeAddToCartButtonToIncreaseDecrease();
	});
	document.addEventListener("DOMContentLoaded", function () {
		changeAddToCartButtonToIncreaseDecrease();
	});
	
	document.addEventListener("ShoptetCartDeleteCartItem", function () {
		removeProductInCartClassIfNotInCart();
	});

	document.addEventListener("luigiSearchDone", function () {
		changeAddToCartButtonToIncreaseDecrease();
	});
	document.addEventListener("RAVENTIC SEARCH RESULTS TRANSFORMED", function () {
		changeAddToCartButtonToIncreaseDecrease();
	});
}

function removeProductInCartClassIfNotInCart() {
	const cartItems = window.dataLayer[0]?.shoptet?.cartInfo?.cartItems || [];
	const cartCodes = cartItems.map((item) => item.code);

	document.querySelectorAll(".product.product-in-cart").forEach((product) => {
		const productCode = product.querySelector(".p-code > span")?.textContent.trim();
		if (productCode && cartCodes.includes(productCode)) {
			return;
		}
		product.classList.remove("product-in-cart");
		product.querySelector(".increase-decrease-wrapper")?.remove();
	});
}

function changeAddToCartButtonToIncreaseDecrease() {
	removeProductInCartClassIfNotInCart();
	const cartItems = window.dataLayer[0]?.shoptet?.cartInfo?.cartItems || [];

	if (!cartItems || cartItems.length === 0) {
		console.warn("No cart items found in the dataLayer.");
		return;
	}
	// Extract all the codes and quantities into an array of objects
	const cartItemCodesAndQuantities = cartItems.map((item) => ({
		code: item.code,
		quantity: item.quantity,
		priceId: item.priceId, // Include priceId if needed
		itemId: item.itemId, // Include itemId if needed
	}));

	const allProducts = document.querySelectorAll(".product");
	if (!allProducts || allProducts.length === 0) {
		console.warn("No products found on the page.");
		return;
	}

	allProducts.forEach((product) => {
		const productCode = product.querySelector(".p-code > span").textContent.trim();

		if (!productCode) {
			console.warn("Product code not found for a product.");
			return;
		}
		if (!cartItemCodesAndQuantities.some((item) => item.code === productCode)) {
			return; // Skip products not in the cart
		}
		// NOTE: the old code assigned productAddButton as an implicit global;
		// declared locally here because ESM modules run in strict mode.
		const productAddButton = product.querySelector(".p-tools .add-to-cart-button");
		if (!productAddButton) {
			console.warn(`Add to cart button not found for product with code ${productCode}.`);
			return; // Skip if no add to cart button
		}
		const selectedProductFromCart = cartItemCodesAndQuantities.find((item) => item.code === productCode);
		if (product.classList.contains("product-in-cart")) {
			if (selectedProductFromCart.quantity === 0) {
				shoptet.cartShared.removeFromCart({ itemId: selectedProductFromCart.itemId });
				product.classList.remove("product-in-cart");
				product.querySelector(".increase-decrease-wrapper").remove();
				return; // Skip if quantity is 0
			}
			product.querySelector(".quantity-input").value = selectedProductFromCart.quantity || "1"; // Default to 1 if not found
			return; // Skip if already processed
		}
		product.classList.add("product-in-cart");

		const increaseDecreaseWrapper = document.createElement("div");
		increaseDecreaseWrapper.className = "increase-decrease-wrapper";
		const increaseButton = document.createElement("div");
		increaseButton.className = "increase-button";
		increaseButton.innerHTML = "+";
		const decreaseButton = document.createElement("div");
		decreaseButton.className = "decrease-button";
		decreaseButton.innerHTML = "-";
		const quantityInput = document.createElement("input");
		quantityInput.className = "quantity-input";
		quantityInput.type = "number";

		quantityInput.value = selectedProductFromCart.quantity || "1"; // Default to 1 if not found
		quantityInput.min = "1"; // Minimum value
		quantityInput.max = "999"; // Maximum value
		quantityInput.setAttribute("data-product-code", productCode); // Store the product code
		increaseDecreaseWrapper.appendChild(decreaseButton);

		increaseDecreaseWrapper.appendChild(quantityInput);
		increaseDecreaseWrapper.appendChild(increaseButton);

		product.querySelector(".p-tools>*").appendChild(increaseDecreaseWrapper);

		if (document.body.classList.contains("id--11")) {
			product.querySelector(".p-tools").appendChild(increaseDecreaseWrapper);
		}

		increaseButton.addEventListener("click", function () {
			quantityInput.value = parseInt(quantityInput.value) + 1;
			quantityInput.dispatchEvent(new Event("change")); // Manually trigger the change event
		});
		decreaseButton.addEventListener("click", function () {
			if (parseInt(quantityInput.value) <= 1) {
				quantityInput.value = 0;
				quantityInput.dispatchEvent(new Event("change")); // Manually trigger the change event
				return;
			}
			quantityInput.value = parseInt(quantityInput.value) - 1;
			quantityInput.dispatchEvent(new Event("change")); // Manually trigger the change event
		});

		function debounce(func, delay) {
			let timeout;
			return function (...args) {
				clearTimeout(timeout);
				timeout = setTimeout(() => func.apply(this, args), delay);
			};
		}

		quantityInput.addEventListener(
			"change",
			debounce(function () {
				const quantityInputValue = parseInt(quantityInput.value);
				if (parseInt(quantityInputValue) < 1) {
					shoptet.cartShared.removeFromCart({ itemId: selectedProductFromCart.itemId });
					product.classList.remove("product-in-cart");
					product.querySelector(".increase-decrease-wrapper").remove();
				} else {
					shoptet.cartShared.updateQuantityInCart({
						itemId: selectedProductFromCart.itemId,
						priceId: selectedProductFromCart.priceId,
						amount: quantityInputValue,
					});
				}
			}, 1000), // Debounce delay of 200ms
		);
	});
}
